var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    { ref: "form" },
    [
      _c(
        "v-card-text",
        [
          _c("v-combobox", {
            attrs: {
              label: "Location Name",
              rules: [_vm.rules.required],
              items: _vm.formObject.dataTypes,
              "item-text": "name",
              "item-value": "name",
              "hide-details": "",
              "return-object": false,
            },
            scopedSlots: _vm._u([
              {
                key: "item",
                fn: function ({ item }) {
                  return [
                    _c(
                      "v-list-tile-content",
                      [
                        _c("v-list-tile-title", {
                          domProps: { innerHTML: _vm._s(item.name) },
                        }),
                        _vm._v(" "),
                        _c("v-list-tile-sub-title", {
                          domProps: { innerHTML: _vm._s(item.type) },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.locationName,
              callback: function ($$v) {
                _vm.locationName = $$v
              },
              expression: "locationName",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }